const { request } = require('./request')

// 协办人员管理模块

// 获取协办人员信息分页列表
function selectCoOrganizerListAPI(data) {
    return request({
        url: '/sys/actOfflineWorker/selectListPage',
        method: 'POST',
        data: data
    })
}

// 根据ID查询协办人员信息
function selectCoOrganizerByIdAPI(data) {
    return request({
        url: '/sys/actOfflineWorker/getActOfflineWorker',
        method: 'POST',
        data: data
    })
}

// 新增或修改协办人员信息
function saveAndUpdateCoOrganizerAPI(data) {
    return request({
        url: '/sys/actOfflineWorker/actOfflineWorkerSave',
        method: 'POST',
        data: data
    })
}

module.exports = {
    selectCoOrganizerListAPI,
    selectCoOrganizerByIdAPI,
    saveAndUpdateCoOrganizerAPI
}
